import { useMemo } from 'react';

import { useNovaContext } from '../../../providers';
import type { SettingsEmployee } from '../../settings-people/employee-utils';
import { SettingsPeopleDialog } from '../../settings-people/people-dialog';

export function AddPeopleDialog({
  open,
  excludedUserUuids,
  onClose,
  onAddPeople,
}: {
  open: boolean;
  excludedUserUuids: Set<string>;
  onClose: () => void;
  onAddPeople: (employees: SettingsEmployee[]) => Promise<boolean>;
}) {
  const { userUuid } = useNovaContext();
  const excluded = useMemo(() => new Set([...excludedUserUuids, userUuid]), [excludedUserUuids, userUuid]);
  if (!open) return null;
  return (
    <SettingsPeopleDialog
      excludedUserUuids={excluded}
      description="Search for teammates and grant them access to this skill."
      hideDescription
      onClose={onClose}
      onSubmit={async (employees) => ({
        failedUserUuids: (await onAddPeople(employees)) ? [] : employees.map((employee) => employee.userUuid),
      })}
    />
  );
}
